exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".store-item .store-logo img[data-v-10bac8dc]{display:block;max-width:100px}.timeline .timeline-item[data-v-10bac8dc]:before{top:28%}.timeline .timeline-item.ready[data-v-10bac8dc]:before{top:15%;height:85px}@media screen and (max-width:1368px) and (min-width:992px){.below-1368[data-v-10bac8dc]{width:80%!important}}", ""]);

// exports
